import { defineComponent as B, computed as l, h as s } from "vue";
import { useRtl as E } from "./ghl-ui.es851.js";
import { setup as F, radioBaseProps as I } from "./ghl-ui.es1082.js";
import O from "./ghl-ui.es1083.js";
import c from "./ghl-ui.es855.js";
import { createKey as n } from "./ghl-ui.es384.js";
import j from "./ghl-ui.es854.js";
import { useThemeClass as H } from "./ghl-ui.es857.js";
import { resolveWrappedSlot as T } from "./ghl-ui.es860.js";
import V from "./ghl-ui.es1084.js";
const L = Object.assign(Object.assign({}, c.props), I), Y = B({
  name: "Radio",
  props: L,
  setup(o) {
    const e = F(o), d = c("Radio", "-radio", O, V, o, e.mergedClsPrefix), a = l(() => {
      const {
        mergedSize: {
          value: t
        }
      } = e, {
        common: {
          cubicBezierEaseInOut: b
        },
        self: {
          boxShadow: f,
          boxShadowActive: p,
          boxShadowDisabled: v,
          boxShadowFocus: g,
          boxShadowHover: C,
          color: R,
          colorDisabled: x,
          colorActive: S,
          textColor: w,
          textColorDisabled: z,
          dotColorActive: $,
          dotColorDisabled: _,
          labelPadding: D,
          labelLineHeight: k,
          labelFontWeight: P,
          [n("fontSize", t)]: y,
          [n("radioSize", t)]: A
        }
      } = d.value;
      return {
        "--n-bezier": b,
        "--n-label-line-height": k,
        "--n-label-font-weight": P,
        "--n-box-shadow": f,
        "--n-box-shadow-active": p,
        "--n-box-shadow-disabled": v,
        "--n-box-shadow-focus": g,
        "--n-box-shadow-hover": C,
        "--n-color": R,
        "--n-color-active": S,
        "--n-color-disabled": x,
        "--n-dot-color-active": $,
        "--n-dot-color-disabled": _,
        "--n-font-size": y,
        "--n-radio-size": A,
        "--n-text-color": w,
        "--n-text-color-disabled": z,
        "--n-label-padding": D
      };
    }), {
      inlineThemeDisabled: r,
      mergedClsPrefixRef: h,
      mergedRtlRef: m
    } = j(o), u = E("Radio", m, h), i = r ? H("radio", l(() => e.mergedSize.value[0]), a, o) : void 0;
    return Object.assign(e, {
      rtlEnabled: u,
      cssVars: r ? void 0 : a,
      themeClass: i == null ? void 0 : i.themeClass,
      onRender: i == null ? void 0 : i.onRender
    });
  },
  render() {
    const {
      $slots: o,
      mergedClsPrefix: e,
      onRender: d,
      label: a
    } = this;
    return d == null || d(), s("label", {
      class: [`${e}-radio`, this.themeClass, this.rtlEnabled && `${e}-radio--rtl`, this.mergedDisabled && `${e}-radio--disabled`, this.renderSafeChecked && `${e}-radio--checked`, this.focus && `${e}-radio--focus`],
      style: this.cssVars
    }, s("input", {
      ref: "inputRef",
      type: "radio",
      class: `${e}-radio-input`,
      value: this.value,
      name: this.mergedName,
      checked: this.renderSafeChecked,
      disabled: this.mergedDisabled,
      onChange: this.handleRadioInputChange,
      onFocus: this.handleRadioInputFocus,
      onBlur: this.handleRadioInputBlur
    }), s("div", {
      class: `${e}-radio__dot-wrapper`
    }, " ", s("div", {
      class: [`${e}-radio__dot`, this.renderSafeChecked && `${e}-radio__dot--checked`]
    })), T(o.default, (r) => !r && !a ? null : s("div", {
      ref: "labelRef",
      class: `${e}-radio__label`
    }, r || a)));
  }
});
export {
  Y as default,
  L as radioProps
};
